import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue")),
  home: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/home.vue"))
}